"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var braft_utils_1 = require("braft-utils");
var react_1 = __importDefault(require("react"));
var ControlBarButton_1 = __importDefault(require("./ControlBarButton"));
var transifex_1 = require("../../../transifex");
var inlineStyles = [
    {
        style: "bold",
        icon: react_1.default.createElement(icons_1.BoldOutlined, null),
        tooltip: transifex_1.TX_BOLD,
    },
    {
        style: "italic",
        icon: react_1.default.createElement(icons_1.ItalicOutlined, null),
        tooltip: transifex_1.TX_ITALIC,
    },
    {
        style: "strikethrough",
        icon: react_1.default.createElement(icons_1.StrikethroughOutlined, null),
        tooltip: transifex_1.TX_STRIKE_THROUGH,
    },
    {
        style: "underline",
        icon: react_1.default.createElement(icons_1.UnderlineOutlined, null),
        tooltip: transifex_1.TX_UNDERLINE,
    },
];
var InlineStyle = function (_a) {
    var editorState = _a.editorState, toggleInlineStyle = _a.toggleInlineStyle;
    return (react_1.default.createElement(antd_1.Row, { gutter: 8 }, inlineStyles.map(function (_a) {
        var icon = _a.icon, tooltip = _a.tooltip, style = _a.style;
        return (react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(ControlBarButton_1.default, { active: braft_utils_1.ContentUtils.selectionHasInlineStyle(editorState, style), onClick: function () { return toggleInlineStyle(style); }, tooltip: tooltip, icon: icon })));
    })));
};
exports.default = InlineStyle;
